(function () {
  console.log('AJAX Section Loader: Script loaded');
  
  // Set up global error handler to catch syntax errors from dynamically loaded scripts
  const originalErrorHandler = window.onerror;
  window.onerror = function(msg, source, lineno, colno, error) {
    // Check if error is related to section loading
    if (source && (source.includes('section-loader') || source === window.location.href)) {
      console.error('AJAX Section Loader: Caught script error:', msg, 'at', source, 'line', lineno);
      // Log but don't break - let original handler also process it
      if (originalErrorHandler) {
        return originalErrorHandler.apply(this, arguments);
      }
      // Return false to allow default error handling, but we've logged it
      return false;
    }
    // Let other errors through to original handler
    if (originalErrorHandler) {
      return originalErrorHandler.apply(this, arguments);
    }
    return false;
  };
  
  if (window.Shopify && Shopify.designMode) {
    console.log('AJAX Section Loader: Skipping in Theme Editor');
    return; // never defer in editor
  }

  // Check for Liquify/Webflow conflicts
  if (typeof LiquifyHelper === 'undefined') {
    console.warn('AJAX Section Loader: LiquifyHelper not found, may cause conflicts');
  }

  function initAjaxLoader() {
    console.log('AJAX Section Loader: Initializing...');
    const placeholders = Array.from(document.querySelectorAll('.DeferredSection[data-section-id]'));
    console.log('AJAX Section Loader: All DeferredSection elements:', document.querySelectorAll('.DeferredSection'));
    console.log('AJAX Section Loader: All elements with data-section-id:', document.querySelectorAll('[data-section-id]'));
    console.log('AJAX Section Loader: All ajax-section-placeholder elements:', document.querySelectorAll('.ajax-section-placeholder'));
    
    // Debug: Check specifically for testimonials section
    const testimonialsSection = document.querySelector('.DeferredSection[data-section-id*="testimonials"]');
    console.log('AJAX Section Loader: Testimonials section found:', testimonialsSection);
    
    if (!placeholders.length) {
      console.log('AJAX Section Loader: No deferred sections found, exiting');
      return;
    }
  
    console.log('AJAX Section Loader: Found', placeholders.length, 'deferred sections');
    placeholders.forEach(ph => {
      console.log('AJAX Section Loader: Observing section', ph.getAttribute('data-section-id'), ph);
    });

    // IntersectionObserver to trigger prefetch when near viewport
    const observer = new IntersectionObserver(onIntersect, {
      rootMargin: '400px 0px', // global prefetch window
      threshold: 0
    });

    const queue = new Set();
    placeholders.forEach(ph => observer.observe(ph));

  let inflight = false;
  function onIntersect(entries) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const sectionId = el.getAttribute('data-section-id');
      console.log('AJAX Section Loader: Section entered viewport', sectionId);
      observer.unobserve(el);
      queue.add(sectionId);
    });
    // batch load next tick
    scheduleFlush();
  }

  let flushTimer = null;
  function scheduleFlush() {
    if (flushTimer) return;
    flushTimer = requestIdleCallback ? requestIdleCallback(flush, { timeout: 100 }) : setTimeout(flush, 50);
  }

  async function flush() {
    flushTimer = null;
    if (inflight || !queue.size) return;

    inflight = true;
    const ids = Array.from(queue);
    queue.clear();

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('sections', ids.join(','));
      
      console.log('AJAX Section Loader: Fetching sections', ids.join(','));
      console.log('AJAX Section Loader: URL', url.toString());

      const res = await fetch(url.toString(), { 
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (!res.ok) {
        console.error('AJAX Section Loader: HTTP error', res.status, res.statusText);
        throw new Error(`Section fetch failed: ${res.status} ${res.statusText}`);
      }
      
      const json = await res.json();
      
      console.log('AJAX Section Loader: Received response', Object.keys(json));

      ids.forEach(id => {
        const html = json[id];
        if (!html) {
          console.warn('AJAX Section Loader: No HTML received for section', id);
          return; // guard
        }
        const target = document.querySelector(`.DeferredSection[data-section-id="${id}"]`);
        if (!target) {
          console.warn('AJAX Section Loader: Target element not found for section', id);
          return;
        }
        
        console.log('AJAX Section Loader: Replacing section', id, 'with', html.length, 'characters');
        
        // Replace placeholder with real HTML
        // Using outerHTML preserves section root id/classes from server
        try {
          target.outerHTML = html;
          
          // Set up temporary error handler for this section's scripts
          const originalOnError = window.onerror;
          let scriptErrorCaught = false;
          
          window.onerror = function(msg, source, lineno, colno, error) {
            // Check if error is from a script we just loaded
            if (source && (source.includes(id) || source === window.location.href)) {
              scriptErrorCaught = true;
              console.error('AJAX Section Loader: Script syntax/execution error in section', id, ':', msg, 'at line', lineno);
              // Don't prevent default - let it log but continue
              if (originalOnError) {
                return originalOnError.apply(this, arguments);
              }
              return false;
            }
            // Let other errors through to original handler
            if (originalOnError) {
              return originalOnError.apply(this, arguments);
            }
            return false;
          };
          
          // Re-run any inline scripts packaged with the section
          const newSection = document.getElementById(`shopify-section-${id}`) || document.querySelector(`[data-section-id="${id}"]`);
          if (newSection) {
            hydrateScripts(newSection);
          }
          
          // Restore original error handler after scripts have executed
          setTimeout(() => {
            window.onerror = originalOnError;
          }, 500);
          
          // Notify themes that listen for section load (some themes do)
          document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: id } }));
          
          if (!scriptErrorCaught) {
            console.log('AJAX Section Loader: Successfully loaded section', id);
          }
        } catch (e) {
          console.error('AJAX Section Loader: Error processing section', id, ':', e);
          // Continue with other sections
        }
      });
    } catch (e) {
      console.error('AJAX Section Loader: Error loading sections:', e);
      
      // Show error state for failed sections
      ids.forEach(id => {
        const target = document.querySelector(`.DeferredSection[data-section-id="${id}"]`);
        if (target) {
          target.innerHTML = `
            <div class="ajax-section-error">
              <p>Failed to load section content. <button onclick="location.reload()">Retry</button></p>
            </div>
          `;
        }
      });
    } finally {
      inflight = false;
    }
  }
  
  } // Close initAjaxLoader function

  function hydrateScripts(scope) {
    if (!scope) return;
    const scripts = scope.querySelectorAll('script');
    scripts.forEach(old => {
      try {
        // Skip if script is empty or has invalid content
        if (!old.textContent || old.textContent.trim() === '') {
          return;
        }
        
        // Skip application/json or other data scripts
        if (old.type && (old.type.includes('application') || old.type.includes('json'))) {
          return;
        }
        
        const s = document.createElement('script');
        // copy attributes
        Array.from(old.attributes).forEach(a => {
          try {
            s.setAttribute(a.name, a.value);
          } catch (e) {
            console.warn('AJAX Section Loader: Failed to copy attribute', a.name, e);
          }
        });
        
        // Set script content
        const scriptContent = old.textContent;
        if (scriptContent) {
          s.textContent = scriptContent;
        }
        
        // Replace with error handling
        if (old.parentNode) {
          try {
            // Replace script - this will execute it
            // Note: Syntax errors in the script will still throw, but we catch them
            old.parentNode.replaceChild(s, old);
          } catch (e) {
            console.error('AJAX Section Loader: Failed to replace/execute script:', e);
            console.error('AJAX Section Loader: Script content preview:', scriptContent ? scriptContent.substring(0, 200) : 'empty');
            // Try to remove the old script at least
            try {
              if (old.parentNode) {
                old.parentNode.removeChild(old);
              }
            } catch (removeError) {
              console.error('AJAX Section Loader: Failed to remove old script:', removeError);
            }
          }
        }
      } catch (e) {
        console.error('AJAX Section Loader: Error hydrating script:', e);
        // Continue with other scripts even if one fails
      }
    });
  }

  // Wait for jQuery and DOM to be ready
  function waitForDependencies() {
    if (typeof jQuery !== 'undefined' && document.readyState === 'complete') {
      console.log('AJAX Section Loader: Dependencies ready, initializing...');
      initAjaxLoader();
    } else {
      console.log('AJAX Section Loader: Waiting for dependencies...');
      setTimeout(waitForDependencies, 100);
    }
  }

  // Start waiting for dependencies
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForDependencies);
  } else {
    waitForDependencies();
  }
})();
